import React from "react";
import { Spinner } from "reactstrap";

const Loader = () => (
<div>
    <div className="spinner-border spinner-border-sm" role="status">
      {/* <span className="visually-hidden">Loading...</span> */}
    </div> 
  </div>
);
export default Loader;
